import React, { FC } from 'react';
import { connectDeep } from 'redux-utils';
import styled from 'styled-components';

import {
  ContentBlock
} from 'components/v2/Common';

import { ErrorPage } from 'components/v2/ErrorPage';
import Layout from 'components/v2/Layout';
import LoadingPage from 'components/v2/LoadingPage';

import App from 'models/app';
import i18n from 'i18n';

import { savePermissions, triggerUpdateAppPermissions } from 'actions/gallery';
import { updatePermissions } from 'actions/registry';
import PermissionsEditor from 'components/v2/Permission/PermissionsEditor';
import Typography from 'components/v2/Typography';

const Page = styled.div`
  background-color: var(--sys-color--surface);
  min-height: 100%;
  width: 100%;
`;

const Container: FC = ({ children }) => (
  <Layout
    center={i18n('page.Permission.center')()}
    name="Permissions"
    pageElement={<Page>{children}</Page>}
  />
);

const PageSectionTitle = styled(Typography)`
  padding: 16px 16px 0 16px;
`;

const Subtitle = styled(Typography)`
  margin: 8px 16px;
`;

const mapStateToProps = (state: any) => {
  const {
    app: { loading, error, entry }
  } = state.registry;

  let app;
  if (entry) {
    app = App.selectFromState(entry, state);
  }

  return {
    app,
    loading,
    error
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  savePermissions: async (appId: string, grantedPermissions: any) => {
    dispatch(
      savePermissions({
        appId,
        grantedPermissions
      })
    );
    await dispatch(updatePermissions(appId));
    dispatch(triggerUpdateAppPermissions());
  }
});

type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface PermissionsPageProps extends ReduxProps {

}

class PermissionsPage extends React.Component<PermissionsPageProps> {
  render() {
    const { app, loading, error, savePermissions } = this.props;

    const onChange = async (grantedPermissions: any) => {
      savePermissions(this.props.app.id, grantedPermissions);
    }

    if (loading || !app) {
      return (
        <Container>
          <LoadingPage headerHeight={56} />
        </Container>
      );
    }
    if (error || !app || !app.grantedPermissions) {
      return (
        <Container>
          <ErrorPage />
        </Container>
      );
    }

    return (
      <Container>
        <PageSectionTitle variant="titleMedium" color="var(--sys-color--on-surface)">
          {i18n('page.Permission.title')({ appName: app.name })}
        </PageSectionTitle>
        <ContentBlock>
          <PermissionsEditor app={app} onChange={onChange} />
        </ContentBlock>
        <Subtitle variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          {i18n('page.Permission.subtitle')()}
        </Subtitle>
      </Container>
    );
  }
}

export default connectDeep(
  mapStateToProps,
  mapDispatchToProps
)(PermissionsPage);
